module.exports = __webpack_public_path__ + "img/head.0458804a.png";